import { render, staticRenderFns } from "./ai_switch.vue?vue&type=template&id=770ea734&scoped=true"
import script from "./ai_switch.vue?vue&type=script&lang=js"
export * from "./ai_switch.vue?vue&type=script&lang=js"
import style0 from "./ai_switch.vue?vue&type=style&index=0&id=770ea734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770ea734",
  null
  
)

export default component.exports